import React from "react"
import { IScheduleDailyTimelineData, EDayOfWeek, IScheduleShift, IHolidayInstanceForPunch } from "../../../../models"
import TimelineTable from "../../daily_timeline/TimelineTable"
import autobind from "class-autobind"
import AppStateStore from "../../../../stores/AppStateStore"
import AccountStore from "../../../../stores/AccountStore"
import * as utils from "../../../../helpers/utils"
import * as timeHelper from "../../../../helpers/timeHelper"
import { IWeeklyScheduleShift } from "."
import { EnumValues } from "enum-values"
import moment from "moment"
import { green800, grey100 } from "material-ui/styles/colors"
interface IProps {
	readonly: boolean
	weeklyScheduleShifts: IWeeklyScheduleShift[]
	holidays: IHolidayInstanceForPunch[]
	handleUpdateTimelineData(timelineItem: IScheduleDailyTimelineData, rowNumber: number, orderNumber: number): void
	checkValidateNewTimeline(timelineItem: IScheduleDailyTimelineData, rowNumber: number, orderNumber: number): boolean
	handleDeleteTimelineItem(rowNumber: number, orderNumber: number): void
	handleUpdateTimelineItem(item: any, rowNumber: number, orderNumber: number)
}
interface IState {
	width: number
}

export default class WeekTimeline extends React.Component<IProps, IState> {
	constructor(props) {
		super(props)
		this.state = {
			width: 1200
		}
		autobind(this)
	}

	componentWillMount() {
		this.updateDimensions()
	}

	componentDidMount() {
		window.addEventListener("resize", this.updateDimensions)
		AppStateStore.on("change", this.updateDimensions)
	}
	componentWillUnmount() {
		window.removeEventListener("resize", this.updateDimensions)
		AppStateStore.removeListener("change", this.updateDimensions)
	}

	updateDimensions() {
		const width = window.innerWidth - AppStateStore.getLeftNavWidth() - 18 * 2 - 30 * 2
		this.setState({ width })
	}

	getIimelineItemRenderElement(timelineItem: IScheduleDailyTimelineData, rowNumber: number, orderNumber: number) {
		const timelineItemData = this.props.weeklyScheduleShifts[rowNumber].Shifts[orderNumber]
		const position = AccountStore.getCurrentAccount().PositionDefinitions.find((item) => item.Id === timelineItemData.PositionId)
		const backgroundColor = position && position.Color ? position.Color : AccountStore.getPositionDefaultColor()
		const jobName = timelineItemData.JobName
		const shiftTime = `${timeHelper.getTimeStringSimpleFormatFromSimpleTime(timelineItem.StartTime)}-${timeHelper.getTimeStringSimpleFormatFromSimpleTime(timelineItem.EndTime)}`
		return (
			<div style={{ backgroundColor, height: 46, textAlign: "center", display: "flex" }}>
				<div style={{ flex: 0.2 }} />
				<div style={{ display: "flex", flexDirection: "column", justifyContent: "center", color: "white", flex: 1, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
					{jobName &&
						<div title={jobName} className="TextOverflow" style={{ position: "relative" }}>
							{jobName}
						</div>
					}
					<div title={shiftTime} className="TextOverflow" style={{ position: "relative" }}>
						{shiftTime}
					</div>
				</div>
				<div style={{ flex: 0.1 }} />
				<div
					style={{
						whiteSpace: "nowrap",
						overflow: "hidden",
						textOverflow: "ellipsis",
						flex: 1,
						height: 30,
						marginTop: 8,
						fontSize: 15,
						borderRadius: 15,
						backgroundColor: utils.getMaterial900ColorFrom500Color(backgroundColor),
						color: "rgba(254, 254, 254, 0.5)",
					}}
				>
					<div style={{ marginTop: 5 }}>
						{timelineItemData.Name}
					</div>
				</div>
				<div style={{ flex: 0.2 }} />
			</div>
		)
	}

	render() {
		const timelineData: IScheduleDailyTimelineData[][] = new Array(this.props.weeklyScheduleShifts.length)
		this.props.weeklyScheduleShifts.forEach((item, index) => {
			const dailyTimelineData: IScheduleDailyTimelineData[] = []
			item.Shifts.length ?
				item.Shifts.forEach(st => {
					dailyTimelineData.push({ StartTime: st.StartTime, EndTime: st.EndTime, Used: st.Used, PunchedIn: st.PunchInTime !== null, PunchedOut: st.PunchOutTime !== null, Breaks: st.Breaks })
					timelineData[index] = dailyTimelineData
				}) :
				timelineData[index] = []
		})
		return (
			<TimelineTable
				items={this.props.weeklyScheduleShifts}
				timelineData={timelineData}
				timelineItemRenderElement={this.getIimelineItemRenderElement}
				leftSideColumns={[
					{
						HeaderLabel: "",
						Col: (row: IWeeklyScheduleShift) => {
							const holiday = this.props.holidays && this.props.holidays.find(item => moment(item.Holiday).isSame(moment(row.ReferenceDate).utc(true)))
							return (
								<div style={{ position: "relative", textAlign: "center", width: "100%", height: "100%", backgroundColor: holiday && green800, color: holiday && grey100 }}>
									<span style={{ marginTop: 5 }}>{holiday && holiday.HolidayName}</span>
									<div style={{ position: "absolute", left: 20, top: 10, fontSize: 16, }}>
										{EnumValues.getNameFromValue(EDayOfWeek, moment(row.ReferenceDate).day()).toUpperCase()}
									</div>
									<div style={{ position: "absolute", fontSize: 10, left: 20, top: 25 }}>{moment(row.ReferenceDate).format("MMM DD").toUpperCase()}</div>
									<div style={{ position: "absolute", right: 0, display: "inline-block", width: 110, textAlign: "left", top: 14 }}>
										{row.Shifts.length > 0 &&
											`${timeHelper.getTimeStringSimpleFormatFromSimpleTime(row.Shifts.reduce((startShift: IScheduleShift, shift) => moment(shift.StartDateTime).isBefore(moment(startShift.StartDateTime)) ? shift : startShift).StartTime)} - 
											${timeHelper.getTimeStringSimpleFormatFromSimpleTime(row.Shifts.reduce((endShift: IScheduleShift, shift) => moment(shift.EndDateTime).isAfter(moment(endShift.EndDateTime)) ? shift : endShift).EndTime)}`
										}
									</div>
								</div>
							)
						},
						ColStyle: { textAlign: "left", cursor: "default", paddingLeft: 0, paddingRight: 0 }
					}
				]}
				multiSelectable={false}
				selectable={false}
				showCheckboxes={false}
				readonly={this.props.readonly}
				timelineTableWidth={this.state.width}
				leftSideWidth={275}
				referenceFieldNameForEdit="Shifts"
				handleUpdateTimelineData={this.props.handleUpdateTimelineData}
				checkValidateNewTimeline={this.props.checkValidateNewTimeline}
				handleDeleteTimelineItem={this.props.handleDeleteTimelineItem}
				handleUpdateTimelineItem={this.props.handleUpdateTimelineItem}
			/>
		)
	}
}
